import { z } from 'zod';

/* ===========================================================================
 * WHO IS IN AT THIS SITE TODAY, FROM EVERY TABLET — `GET /api/field/workers/today`.
 *
 * Each tablet built its roster from its own punches, so a worker who checked
 * in on tablet A and out on tablet B read "not in yet" on B and "inside" on A
 * for the rest of the day, and the two tablets at one gate printed different
 * In/Out counts. This is the server's half of the fix: per worker, the last
 * admitted check-in and check-out TODAY (company day) at the asking device's
 * worksite, from any device or terminal. The tablet merges it with its own
 * punches — newer stamp wins — so an offline tablet still works from its own
 * and converges after the next sync (apps/field/src/lib/siteTodayMerge.ts).
 *
 * Small on purpose: one entry per worker who punched today, nothing else — no
 * device ids, no photos, no scores, no names (the tablet already holds those).
 * ======================================================================== */

export const FieldSiteTodayWorkerSchema = z.object({
  /** The worker's employeeCode — the tablet's `workerId`. */
  code: z.string(),
  /** ISO instant of today's last admitted PUNCH_IN here, or null when none. */
  lastIn: z.string().nullable(),
  /** ISO instant of today's last admitted PUNCH_OUT here, or null when none. */
  lastOut: z.string().nullable(),
});
export type FieldSiteTodayWorker = z.infer<typeof FieldSiteTodayWorkerSchema>;

export const FieldSiteTodaySchema = z.object({
  /** The company day these stamps belong to (YYYY-MM-DD, docs/time-and-dates.md).
   *  A tablet whose own company day is different ignores the whole answer. */
  day: z.string(),
  workers: z.array(FieldSiteTodayWorkerSchema),
});
export type FieldSiteToday = z.infer<typeof FieldSiteTodaySchema>;
